import React from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';
import classNames from 'classnames';

import { Mail, MailChunky } from '@eb/eds-iconography';

import NotificationScreen from '../../components/NotificationScreen';
import SplitContainer from '../../connectedComponents/SplitContainer';

import './ResetPasswordStatusPage.scss';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/RESET_PASSWORD_STATUS_PATH
 */
export default class ResetPasswordStatusPage extends React.PureComponent {
    static propTypes = {
        email: PropTypes.string,
        usesNewStyles: PropTypes.bool,
    };

    render() {
        const { email, usesNewStyles } = this.props;
        const headerText = gettext('Check your email');
        const componentClasses = classNames('eds-l-mar-vert-14', {
            'reset-password-status-page': usesNewStyles,
        });
        let iconProps = {
            iconType: <Mail />,
        };
        let subtitleText = gettext(
            'We sent you an email with instructions to reset your password.',
        );

        if (usesNewStyles) {
            iconProps = {
                iconColor: 'ui-700',
                iconType: <MailChunky />,
            };
        }

        //Need to conditionally check if the email is present and update copy accordingly
        //in case the user refreshes the notification page and we lose the email from state.
        if (email) {
            subtitleText = gettext(
                'We sent an email to %(email)s with instructions to reset your password.',
                { email },
            );
        }

        return (
            <SplitContainer
                shouldShowSecondaryPanel={usesNewStyles}
                usesNewStyles={usesNewStyles}
            >
                <div className={componentClasses}>
                    <NotificationScreen
                        {...iconProps}
                        headerText={headerText}
                        subtitleText={subtitleText}
                        usesNewStyles={usesNewStyles}
                    />
                </div>
            </SplitContainer>
        );
    }
}
